import { render, staticRenderFns } from "./SiteTaxTypeTable.vue?vue&type=template&id=9cc5e102&"
import script from "./SiteTaxTypeTable.vue?vue&type=script&lang=js&"
export * from "./SiteTaxTypeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports